(function () {
  if (window.tabOfferlyTrackingLoaded) return;
  window.tabOfferlyTrackingLoaded = true;

  const modalSelector = '#OfferlyModalDiv';
  let wasOpen = false;

  function track(eventName, details = {}) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, {
        ...details,
        page_location: window.location.href
      });
    } else {
      console.warn('GA4 tag unavailable:', eventName);
    }
  }

  function isPopupOpen() {
    const modal = document.querySelector(modalSelector);
    if (!modal) return false;

    const style = window.getComputedStyle(modal);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity) > 0
    );
  }

  function checkPopup() {
    const open = isPopupOpen();

    if (open && !wasOpen) {
      track('offer_popup_view');
    }

    wasOpen = open;
  }

  document.addEventListener('click', function (event) {
    const target = event.target;

    if (target.closest('#offerButton')) {
      track('offer_button_click');
    }

    if (target.closest('#offerlyCloseButton')) {
      track('offer_popup_close');
    }

    if (target.closest('#submitOfferButton')) {
      track('offer_submit_click');
    }

    setTimeout(checkPopup, 100);
  }, true);

  const observer = new MutationObserver(checkPopup);

  function initialize() {
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'class']
    });

    checkPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();